import React, {useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Link} from "@pg-design/link-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {comparisonToolAnalytics, ComparisonToolGTMTableAction} from "../../../utils/comparison_tool_analytics";

interface IProps {
    phoneNumber: string | null;
    isPrinting: boolean;
}

export const ShowPhoneButton = (props: IProps) => {
    const [showPhone, setShowPhone] = useState<boolean>(false);

    if (!props.phoneNumber) {
        return <div css={phoneButton}>-</div>;
    }

    const onShowPhoneNumber = () => {
        setShowPhone(true);

        comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.PHONE_REVEAL);
    };

    return (
        <div css={phoneButton}>
            {showPhone || props.isPrinting ? (
                <Link href={`tel:+${props.phoneNumber}`}>{phoneNumberFormat(props.phoneNumber)}</Link>
            ) : (
                <Button onClick={onShowPhoneNumber} type="button" variant="highlight_primary">
                    Pokaż numer
                </Button>
            )}
        </div>
    );
};

const phoneButton = css`
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
`;
import React, {useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Link} from "@pg-design/link-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {comparisonToolAnalytics, ComparisonToolGTMTableAction} from "../../../utils/comparison_tool_analytics";

interface IProps {
    phoneNumber: string | null;
    isPrinting: boolean;
}

export const ShowPhoneButton = (props: IProps) => {
    const [showPhone, setShowPhone] = useState<boolean>(false);

    if (!props.phoneNumber) {
        return <div css={phoneButton}>-</div>;
    }

    const onShowPhoneNumber = () => {
        setShowPhone(true);

        comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.PHONE_REVEAL);
    };

    return (
        <div css={phoneButton}>
            {showPhone || props.isPrinting ? (
                <Link href={`tel:+${props.phoneNumber}`}>{phoneNumberFormat(props.phoneNumber)}</Link>
            ) : (
                <Button onClick={onShowPhoneNumber} type="button" variant="highlight_primary">
                    Pokaż numer
                </Button>
            )}
        </div>
    );
};

const phoneButton = css`
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
`;
